export const destaques = [
  {
    title: 'Praia de Encantadas',
    tag: 'Praia',
    description:
      'A mais famosa da ilha. Mar calmo, areia branca e o cenário perfeito para relaxar.',
    image: '/images/praia-encantadas.jpg',
    link: '/praias/praia-das-encantadas-ilha-do-mel',
  },
  {
    title: 'Farol das Conchas',
    tag: 'Atração',
    description:
      'Vista de 360° do alto do morro. O pôr do sol daqui é um dos mais lindos do Brasil.',
    image: '/images/morro-farol-vista.jpg',
    link: '/ponto-turistico/farol-das-conchas',
  },
  {
    title: 'Gruta das Encantadas',
    tag: 'Atração',
    description: 'Formação rochosa milenar com lenda indígena. A trilha até aqui já vale a viagem.',
    image: '/images/gruta-encantadas.jpg',
    link: '/ponto-turistico/gruta-das-encantadas',
  },
  {
    title: 'Fortaleza de N. S. dos Prazeres',
    tag: 'Atração',
    description: 'Fortaleza colonial do século XVIII com vista espetacular para o mar.',
    image: '/images/fortaleza.jpg',
    link: '/ponto-turistico/fortaleza-nossa-senhora-dos-prazeres',
  },
];

export const roteiros = [
  {
    dias: '1',
    titulo: 'O essencial da ilha',
    desc: 'Praia de Encantadas, Gruta das Encantadas e o pôr do sol no Trapiche.',
    imagem: '/images/praia-encantadas.jpg',
    paradas: ['Praia de Encantadas', 'Gruta das Encantadas', 'Trapiche de Encantadas'],
  },
  {
    dias: '2',
    titulo: 'Natureza + História',
    desc: 'Dia 1: sul da ilha. Dia 2: Farol, Fortaleza e Praia do Farol.',
    imagem: '/images/morro-farol-vista.jpg',
    paradas: ['Farol das Conchas', 'Fortaleza', 'Praia do Farol', 'Praia de Encantadas'],
  },
  {
    dias: '3',
    titulo: 'A ilha toda',
    desc: 'Os 3 dias perfeitos: praias, trilhas, história e o passeio de vela.',
    imagem: '/images/sailboat.jpg',
    paradas: ['Todas as praias', 'Todas as trilhas', 'Passeio de vela', 'Farol + Fortaleza'],
  },
];

export const dicas = [
  { icon: '💰', title: 'Dinheiro em espécie', desc: 'Não há caixa eletrônico nem banco na ilha.' },
  { icon: '💡', title: 'Lanterna', desc: 'Não há iluminação pública à noite.' },
  { icon: '📱', title: 'Internet é limitada', desc: 'Aproveite para desconectar de verdade.' },
  {
    icon: '🏪',
    title: 'Leve do mercado',
    desc: 'Com cozinha? Insumos do continente saem mais baratos.',
  },
];

export const depoimentos = [
  {
    nome: 'Mariana S.',
    local: 'São Paulo, SP',
    texto:
      'Achei que seria complicado chegar, mas com o guia do site foi super tranquilo. A dica da lanterna salvou minha noite!',
    nota: 5,
  },
  {
    nome: 'Pedro e Ana',
    local: 'Curitiba, PR',
    texto:
      'Fizemos o passeio de 2 dias seguindo o roteiro do site. Vimos tudo que importa sem correria. A Praia de Encantadas é um paraíso.',
    nota: 5,
  },
  {
    nome: 'Roberto K.',
    local: 'Florianópolis, SC',
    texto:
      'Reservei a pousada direto pelo WhatsApp. Melhor preço que no Booking e a dona ainda deu dicas de trilhas secretas.',
    nota: 5,
  },
  {
    nome: 'Camila R.',
    local: 'Rio de Janeiro, RJ',
    texto:
      'Levei meus pais de 70 anos e eles adoraram. A trilha Encantadas-Nova Brasília é plana e linda. Já estamos planejando voltar no verão.',
    nota: 5,
  },
  {
    nome: 'Fernando L.',
    local: 'Porto Alegre, RS',
    texto:
      'O Passeio 360° com a Carol foi o ponto alto da viagem. Nadar com os peixes na Praia de Fora é uma experiência única. Recomendo demais!',
    nota: 5,
  },
  {
    nome: 'Juliana e Marcos',
    local: 'Belo Horizonte, MG',
    texto:
      'Fomos em casal e a vibe da ilha é perfeita para desconectar. Sem carro, sem pressa, só natureza. O restaurante Fim da Trilha é imperdível.',
    nota: 5,
  },
];

export const categoryConfig = [
  {
    id: 'praias',
    slug: 'praia',
    title: 'Praias',
    count: 7,
    description: 'Do mar calmo ao surf selvagem',
    icon: '🏖️',
  },
  {
    id: 'trilhas',
    slug: 'trilha',
    title: 'Trilhas',
    count: 6,
    description: 'Caminhadas para todos os níveis',
    icon: '🥾',
  },
  {
    id: 'atracoes',
    slug: 'atracao',
    title: 'Atrações',
    count: 7,
    description: 'Farol, Gruta, Fortaleza e mais',
    icon: '🏛️',
  },
  {
    id: 'passeios',
    slug: 'passeio',
    title: 'Passeios',
    count: 2,
    description: 'Guiados com moradores locais',
    icon: '⛵',
  },
  {
    id: 'pousadas',
    slug: 'pousada',
    title: 'Pousadas',
    count: 1,
    description: 'Onde ficar em cada vilarejo',
    icon: '🏡',
  },
  {
    id: 'restaurantes',
    slug: 'restaurante',
    title: 'Restaurantes',
    count: 2,
    description: 'Onde comer bem na ilha',
    icon: '🍽️',
  },
];
